import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Box, Stack, Paper, Avatar, Typography, Dialog, DialogContent, DialogContentText, } from "@mui/material";
import { useArchiveSecureMessageMutation, useCreateNewSecureReplyMutation, SecureMessagesByPartyDocument, } from "generated/generated-models";
import ArchiveIcon from "@mui/icons-material/Archive";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import MessageTypeBar from "./MessageTypeBar";
import React, { useEffect, useRef, useState } from "react";
import MailIcon from "@mui/icons-material/MailOutlined";
import { FileThumb } from "app/disbursement/FileThumb";
import { FileUploader } from "./FileUploader";
import { CError } from "app/common/CError";
import ViewAllAttachments from "./ViewAllAttachments";
import dayjs from "dayjs";
import { Guid } from "guid-typescript";
const MessageChainView = (props) => {
    const [createNewSecureReply] = useCreateNewSecureReplyMutation();
    const [handleArchiving] = useArchiveSecureMessageMutation();
    const [currentMessage, setCurrentMessage] = useState(props.secureMessage);
    const [error, setError] = useState("");
    const [files, setFiles] = useState([]);
    const [fileData, setFileData] = useState([]);
    const [open, setOpen] = useState(false);
    const bottom = useRef(null);
    const scrollToBottom = () => {
        bottom?.current?.scrollIntoView({ behavior: "smooth" });
    };
    useEffect(() => {
        scrollToBottom();
        setCurrentMessage(props.secureMessage);
        async function validateTotalFileSize() {
            const error = await FileUploader.validateTotalFileSize(files.map((x) => x.file));
            setError(error || null);
        }
        validateTotalFileSize();
    }, [props.secureMessage, files]);
    if (currentMessage == null || currentMessage.ToDoItem.Messages == null) {
        return (_jsxs(Box, { sx: { my: 12, textAlign: "center" }, className: "messageNote", children: [_jsx(MailIcon, { sx: { mb: 0.7 } }), _jsx("p", { style: { fontSize: 14 }, children: "Select an item to read" })] }));
    }
    async function handleSubmit(messageBody) {
        if ((messageBody == null || messageBody === "") &&
            (!fileData || !fileData.length)) {
            return;
        }
        const result = await createNewSecureReply({
            variables: {
                input: {
                    SecureMessageId: currentMessage?.Id,
                    Body: messageBody,
                    FileData: fileData,
                },
            },
            refetchQueries: [{ query: SecureMessagesByPartyDocument }],
        });
        if (result.data?.requestNewSecureReply?.GraphSecureMessage != null) {
            const message = result.data.requestNewSecureReply.GraphSecureMessage;
            message.ToDoItem.Messages = message.ToDoItem.Messages.sort((messageA, messageB) => messageA.CreatedOn > messageB.CreatedOn ? 1 : -1);
            setFiles([]);
            setFileData([]);
            setCurrentMessage(message);
        }
    }
    const handleFileUpload = async (file, data) => {
        const error = await FileUploader.validateFile(file);
        if (error) {
            setError(error);
            return;
        }
        setFiles((prevFiles) => [...prevFiles, { file, id: Guid.raw() }]);
        setFileData((prevFileData) => [
            ...prevFileData,
            {
                fileName: file.name,
                fileSize: file.size,
                data: data,
            },
        ]);
        setError(null);
    };
    const handleRemoveFile = (file) => {
        setFiles((prevFiles) => prevFiles.filter((fileItem) => fileItem.file !== file));
        setFileData((prevFileData) => {
            const updatedFileData = Array.isArray(prevFileData)
                ? prevFileData.filter((fileItem) => fileItem.fileName !== file.name)
                : [];
            return updatedFileData;
        });
    };
    const handleArchivingSubmit = async () => {
        const result = await handleArchiving({
            variables: {
                input: {
                    SecureMessageId: currentMessage?.Id,
                },
            },
            refetchQueries: [{ query: SecureMessagesByPartyDocument }],
        });
        if (result.data?.archiveSecureMessage?.Success !== undefined ||
            result.data?.archiveSecureMessage?.Success === true) {
            setCurrentMessage(null);
        }
    };
    return (_jsxs(Stack, { spacing: 3, className: "messageView", children: [_jsxs(Box, { sx: { ml: 4 }, className: "messageHeader", children: [_jsx("h3", { children: currentMessage.Subject }), _jsxs(Stack, { direction: "row", spacing: 2, className: "messageLinks", children: [currentMessage.Attachments?.some((file) => file?.Name) && (_jsx(Button, { onClick: () => setOpen(true), variant: "text", startIcon: _jsx(AttachFileIcon, {}), children: "View all Attachments" })), _jsx(Button, { id: "archive-secure-message-button", variant: "text", startIcon: _jsx(ArchiveIcon, {}), onClick: handleArchivingSubmit, children: currentMessage.IsArchived
                                    ? "Unarchive Message"
                                    : "Archive Message" })] })] }), _jsx(Box, { sx: {
                    p: 2,
                    pt: 1,
                    ml: 4,
                    mt: 0,
                    height: 580,
                    overflow: "auto",
                }, id: "ChainContainer", className: "messageChainContainer", children: currentMessage.ToDoItem.Messages.map((message, index) => {
                    return (_jsx(React.Fragment, { children: _jsxs(Stack, { direction: message.Party === props.partyId
                                ? "row-reverse"
                                : "row", spacing: 1, children: [_jsxs(Avatar, { sx: {
                                        mt: 1.7,
                                        width: 32,
                                        height: 32,
                                        fontSize: "0.8rem",
                                    }, children: [message.CreatedByFirstName.charAt(0), message.CreatedByLastName.charAt(0)] }), _jsxs(Stack, { alignItems: message.Party === props.partyId
                                        ? "flex-end"
                                        : "flex-start", children: [_jsxs(Paper, { className: message.Party === props.partyId
                                                ? "currentUserMessage"
                                                : "systemReplyMessage", elevation: 3, sx: { p: 2 }, children: [_jsxs(Typography, { children: [" ", message.Text, " "] }), _jsx("div", { ref: bottom })] }), currentMessage != null &&
                                            (index ===
                                                currentMessage.ToDoItem.Messages
                                                    .length -
                                                    1 ||
                                                message.CreatedBy !==
                                                    currentMessage.ToDoItem
                                                        .Messages[index + 1]
                                                        .CreatedBy ||
                                                (new Date(currentMessage.ToDoItem.Messages[index + 1].CreatedOn).getTime() -
                                                    new Date(message.CreatedOn).getTime()) /
                                                    60000 >
                                                    5) && (_jsx(Typography, { variant: "caption", className: "messageDate", sx: {
                                                marginTop: "5px",
                                                marginLeft: "5px",
                                            }, children: dayjs(message.CreatedOn).format("DD MMM YYYY HH:mm") })), message.Attachments &&
                                            message.Attachments.map((file) => (_jsxs(Typography, { variant: "caption", className: "messageDate", children: [_jsx(AttachFileIcon, {}), file?.FileName] }, file?.Id)))] })] }) }, message.Id));
                }) }), error && _jsx(CError, { error: error }), files.map((file) => (_jsx(FileThumb, { file: file.file, onRemove: () => handleRemoveFile(file.file) }, file.id))), currentMessage.Subject !== "Capital Upgrade" &&
                !currentMessage.IsArchived && (_jsx(MessageTypeBar, { handleSubmit: handleSubmit, handleFileUpload: handleFileUpload, error: error !== null })), _jsx(Dialog, { fullScreen: false, className: "add-payee", open: open, onClose: () => setOpen(false), fullWidth: true, children: _jsx(DialogContent, { sx: { m: 4 }, children: _jsx(DialogContentText, { children: _jsx(ViewAllAttachments, { secureMessage: currentMessage }) }) }) })] }));
};
export default MessageChainView;
